import { Navigate } from 'react-router-dom'
import { hasTenantBound } from '@/config/tenant'

interface Props {
  children: React.ReactNode
}

/** Bloqueia rotas da app do cliente sem empresa definida (link /e/slug). */
export function RequireTenantBound({ children }: Props) {
  if (!hasTenantBound()) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
